import React from "react";
import * as styles from "./PaymentMethodStep.module.scss";
import { useDepositWizard } from "features/wallet/components/deposit/hooks/useDepositWizard";
import { PaymentMethodOption } from "./PaymentMethodOption";
import { DestinationOption } from "./DestinationOption";
import { Button, useWizard } from "@picklebet/ui";

export const PaymentMethodStep = () => {
  const {
    selectableMethods,
    destinations,
    selectedMethod,
    setSelectedMethodId,
  } = useDepositWizard();
  const { back, push } = useWizard();

  return (
    <div className={styles.container}>
      <div className={styles.methods}>
        <div
          className={styles.options}
          role="radiogroup"
          aria-label="Payment method"
        >
          {selectableMethods.map((method) => {
            return (
              <PaymentMethodOption
                key={method.id}
                method={method}
                selected={selectedMethod.id === method.id}
                onSelect={(id) => {
                  setSelectedMethodId(id);
                  back();
                }}
              />
            );
          })}
        </div>

        {destinations.map((destination) => (
          <DestinationOption
            key={destination.id}
            destination={destination}
            onNavigate={push}
          />
        ))}
      </div>

      <Button onClick={() => back()}>Done</Button>
    </div>
  );
};
